// src/api/wishlistApi.js
//
// REST wishlist API — https://orbiee-backend-dev-218142584790.us-central1.run.app/docs#/wishlist
//
import { WISHLIST_API_URL } from "../config/apiConfig";
import { getUserProfile } from "../utils/auth";
import { getOrbieeDeviceId } from "../services/websocket";

async function buildWishlistHeaders() {
  const profile = getUserProfile();
  const customerId = profile?.customer_id;
  if (!customerId) return null;

  const deviceId = await getOrbieeDeviceId();
  return {
    "Content-Type": "application/json",
    "X-User-Id": String(customerId),
    "X-Device-Id": String(deviceId),
  };
}

async function parseWishlistResponse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail =
      typeof data.detail === "string"
        ? data.detail
        : data.message ||
          data.error?.message ||
          `Wishlist request failed (${response.status})`;
    throw new Error(detail);
  }
  if (data.success === false) {
    throw new Error(data.message || "Wishlist request failed");
  }
  return data;
}

/**
 * GET /api/wishlist — fetch the shopper's current wishlist.
 */
export async function fetchWishlist() {
  const headers = await buildWishlistHeaders();
  if (!headers) return null;

  const response = await fetch(WISHLIST_API_URL, {
    method: "GET",
    headers,
  });
  return parseWishlistResponse(response);
}

/**
 * POST /api/wishlist — add one article.
 */
export async function addWishlistItem({ article_id }) {
  const headers = await buildWishlistHeaders();
  if (!headers) return null;

  const response = await fetch(WISHLIST_API_URL, {
    method: "POST",
    headers,
    body: JSON.stringify({ article_id: String(article_id) }),
  });
  return parseWishlistResponse(response);
}

/**
 * DELETE /api/wishlist — remove one article.
 */
export async function removeWishlistItem({ article_id }) {
  const headers = await buildWishlistHeaders();
  if (!headers) return null;

  const response = await fetch(WISHLIST_API_URL, {
    method: "DELETE",
    headers,
    body: JSON.stringify({ article_id: String(article_id) }),
  });
  return parseWishlistResponse(response);
}

/**
 * DELETE /api/wishlist?all=true — empty the entire wishlist.
 */
export async function clearWishlistRemote() {
  const headers = await buildWishlistHeaders();
  if (!headers) return null;

  const response = await fetch(`${WISHLIST_API_URL}?all=true`, {
    method: "DELETE",
    headers,
  });
  return parseWishlistResponse(response);
}
